import styled from 'styled-components';

export const FloatButton = styled.div`
  button {
    position: absolute;
  }
`;
